import axios from "axios";
import React, { useEffect, useState } from "react";
import { UseHrApp } from "../utils/context";
import LeavesModal from "./AdminComponents/LeavesModal";
import { CircularProgress } from "@mui/material";

export default function EmployeeLeaves(props) {
  const { EmployeeID, setEmployeeID, Emtoken } = UseHrApp();

  const [leaves, setleaves] = useState([]);

  const [filteredLeaves, setFilteredLeaves] = useState([]); // New state for filtered data

  const [loading,setloading]=useState(true)

  console.log(EmployeeID);
  async function getAllLeaves() {
    try {
      const res = await axios({
        url: `https://hr-app-api.onrender.com/leave/history`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Emtoken}`,
        },
      });
      if (res?.data?.status) {
        setleaves(res?.data?.data.reverse());
        setloading(false)
      }
    } catch (error) {
      console.log("Failed");
    }
  }

  useEffect(() => {
    getAllLeaves();
  }, []);

  return (
    <div>
      <div className="container mx-auto hidden lg:block ">
        {loading ? (<div className="flex justify-center items-center h-[300px]">
            {/* Replace the following line with your preferred loader component */}
            <CircularProgress/>
          </div>)
          :leaves.length === 0  ?( // Check if the leaves array is empty
          <p className=" text-center text-xl mt-[4em] font-medium">No leaves yet</p>
        ) : (
          
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  index
                </th>
                <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Start Date
                </th>
                <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  End Date
                </th>
                <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Duration
                </th>
                <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Reviwed
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {leaves.map((item, index) => (
                <tr key={item.id}>
                  <td className="px-4 py-4 whitespace-no-wrap text-center">
                    {index}
                  </td>
                  <td className="px-4 py-4 whitespace-no-wrap">
                    {new Date(item.startDate).toISOString().slice(0, 10)}
                  </td>
                  <td className="px-4 py-4 whitespace-no-wrap">
                    {new Date(item.endDate).toISOString().slice(0, 10)}
                  </td>
                  <td className={"px-4 py-1  whitespace-no-wrap"}>
                    <div
                      className={
                        item.status === "Approved"
                          ? "h-6 text-[#32bd67] text-center bg-[#eaedf1] rounded-[3em]"
                          : item.status === "Rejected"
                          ? "bg-[#f9d0d0] h-6 text-[#ff0000] text-center rounded-[3em]"
                          : "bg-[#f1f3f5] h-6 text-[#e2bc3e] text-center rounded-[3em]"
                      }
                    >
                      {item.status}
                    </div>
                  </td>
                  <td className="px-4 py-4 whitespace-no-wrap text-center">
                    {item.duration}
                  </td>
                  {item.reviewed && <td className=" text-center">Reviewed</td>}

                  {!item.reviewed && (
                    <td className=" text-center">Not Reviewed</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

/**
 *      <div className=" flex gap-2">
                    <button className="  w-max p-[2px] flex items-center justify-center bg-[#daeaff] "     onClick={()=>{
                   
                    }}>
                      <AiOutlineEye color="black" />{" "}
                    </button>
          
                  </div>
 */
